import React from "react";
import Styles from "./footer.module.scss";
import { Markup } from "interweave";
import { Container } from 'reactstrap';
import GeneralService from "services/generalService";

interface IFooterProps {
}

interface IFooterState {
    footerText: string
}

class Footer extends React.Component<IFooterProps, IFooterState>{

    /**
     *
     */
    constructor(props: IFooterProps) {
        super(props);

        this.state = { footerText: '' }
    }

    componentDidMount() {
        GeneralService.GetGeneral().then(gen => {
            this.setState({ footerText: gen.Footer });
        });
    }

    render() {
        return (
            <div className={Styles.Footer}>
                <Container>
                    <Markup content={this.state.footerText} />
                </Container>
            </div>
        );
    }
}

export default Footer;